// extracted by mini-css-extract-plugin
export var component = "focusWithin-module--component--34-CX";
export var outset = "focusWithin-module--outset--mMwXk";